<template>
  <v-simple-table fixed-header>
    <template v-if="loading">
      <Load :loadingmsg="loadingMsg" />
    </template>
    <div
      v-else
    >
      <v-data-table
        :headers="headers"
        :items="contents"
        :items-per-page="5"
        item-key="id"
      >
        <template #item.name="{ item }">
          {{ item.name }}
        </template>
        <template #item.status="{ item }">
          {{ item.status ? 'Ativo' : 'Inativo' }}
        </template>
        <template #item.created_at="{ item }">
          <v-btn
            class="mx-2"
            outlined
            small
            fab
            color="primary"
            @click="openFormEditItemDialog(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            class="mx-2"
            outlined
            small
            fab
            color="primary"
            @click="confirmDelete(item)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </v-simple-table>
</template>

<script>
import Load from '@/components/Loading.vue'
import FormAddNewItemDialog from '@/components/settings/FormAddNewItemDialog.vue'
import FormEditItemDialog from '@/components/settings/FormEditItemDialog.vue'

import handlesServerValidation from '@/mixins/handles-server-validation.js'

export default {
  components: {
    Load
  },

  mixins: [
    handlesServerValidation
  ],

  data () {
    return {
      gradeVolumeView: false,
      loading: false,
      loadingMsg: '',
      contents: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Slug',
          align: 'start',
          value: 'slug'
        },
        {
          text: 'Ordem',
          align: 'start',
          value: 'order'
        },
        {
          text: 'Status',
          align: 'start',
          value: 'status'
        },
        {
          text: 'Ações',
          align: 'start',
          value: 'created_at'
        }
      ]
    }
  },

  computed: {
    gradeID () {
      return this.$route.params.gradeID
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.listGradeVolumes()
      this.gradeVolumeView = true
    },
    async listGradeVolumes () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        this.contents = await this.$api.listGradeVolumes(this.gradeID)
      } catch (e) {
        this.getErrors(e)
      }
      this.loading = false
    },
    openFormAddNewitemDIalog () {
      this.$dialog.custom(FormAddNewItemDialog).with({ title: 'Volume', action: this.newGradeVolume }).show()
        .then((gradeVolume) => {
          if (!gradeVolume) {
            return false
          }
          this.listGradeVolumes()
        })
    },
    openFormEditItemDialog (gradeVolume) {
      this.$dialog.custom(FormEditItemDialog).with({ title: 'Volume', item: gradeVolume, action: this.updateGradeVolume }).show()
        .then((updatedGradeVolume) => {
          if (!updatedGradeVolume) {
            return false
          }
          this.listGradeVolumes()
        })
    },
    async newGradeVolume (data) {
      await this.$api.newGradeVolume(this.gradeID, data)
    },
    async updateGradeVolume (id, data) {
      await this.$api.updateGradeVolume(id, data)
    },
    async confirmDelete (item) {
      this.$dialog.confirm(`Apagar ${item.name}?`)
        .text('Tem certeza que deseja apagar? não será possível reverter')
        .label('Apagar')
        .onConfirm(async () => {
          await this.deleteGradeVolume(item.id)
        })
        .show()
    },
    async deleteGradeVolume (id) {
      try {
        await this.$api.deleteGradeVolume(id)
        this.$store.dispatch('setSnackBar', { text: 'Volume apagado com sucesso.' })
        this.listGradeVolumes()
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível apagar o Volume, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
<style scoped>
.negativeContainer {
  margin: -32px;
  border-left: 0px;
  border-right: 0px;
}
</style>
